import { Modal } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import RejectReasonModal from "./rejectReason";

interface TeamDocumentModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  quatation: string;
}

export default function TeamDocumentModal({
  open,
  onClose,
  setOpen,
  quatation,
}: TeamDocumentModalProps) {
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <Modal className="modal teamDocument_modal" open={open} onClose={onClose}>
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="modal_title">
              <h2>Quotation Document</h2>
              <div className="btn-close" onClick={() => setOpen(false)}>
                <CloseIcon />
              </div>
            </div>
            <div className="">
              <div className="view_page gap_p">
                <div className="w_100">
                  <h6>Front Image</h6>
                  <figure className="passport_img">
                    <img
                      src={quatation || "/static/images/placeholder.png"}
                      alt="quotation"
                    />
                  </figure>
                </div>
                {/* <div className="w_50">
                  <h6>Back Image</h6>
                  <figure className="passport_img">
                    <img src="/static/images/placeholder.png" alt="Passport" />
                  </figure>
                </div> */}
              </div>
            </div>
            {/* <div className="borderBox">
              <div className="section_title">
                <h2>Passport</h2>
              </div>
              <div className="view_page gap_p">
                <div className="w_100">
                  <h6>Expiry Date</h6>
                  <p>01 Nov 2028</p>
                </div>
                <div className="w_50">
                  <h6>Front Image</h6>
                  <figure className="passport_img">
                    <img src="/static/images/placeholder.png" alt="Passport" />
                  </figure>
                </div>
                <div className="w_50">
                  <h6>Back Image</h6>
                  <figure className="passport_img">
                    <img src="/static/images/placeholder.png" alt="Passport" />
                  </figure>
                </div>
              </div>
            </div> */}
            {/* <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Approve
              </Button>

              <Button
                className="btn btn_danger"
                onClick={() => {
                  setOpen(false);
                  setOpen1(true);
                }}
              >
                Reject
              </Button>
            </div> */}
          </div>
        </div>
      </Modal>

      {/* <RejectReasonModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      /> */}
    </>
  );
}
